import React, { useState } from 'react';
import { Form, Button, Badge } from 'react-bootstrap';
import ModalMataNegocio from './ModalMataNegocio';

const CamposMata = ({ mataNegocioSelecionado, onSelecionar, codigoGrupoEmpresa }) => {
  const [modalAberto, setModalAberto] = useState(false);

  return (
    <Form.Group>
      <Form.Label className="small mb-1 d-block">Mata</Form.Label>
      <Button size="sm" variant="outline-primary" onClick={() => setModalAberto(true)}>
        Buscar Mata
      </Button>
      {mataNegocioSelecionado ? (
        <Badge
          variant="success"
          className="d-block mt-2"
          style={{
            fontSize: '0.875rem',
            padding: '6px 10px',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            textAlign: 'left',
          }}
        >
          {mataNegocioSelecionado.codigo} — {mataNegocioSelecionado.descricao}
        </Badge>
      ) : (
        <div className="text-muted small mt-2">Nenhuma mata selecionada</div>
      )}
      <ModalMataNegocio
        aberto={modalAberto}
        tipo="M"
        codigoGrupoEmpresa={codigoGrupoEmpresa}
        onSelecionar={(item) => {
          onSelecionar(item);
          setModalAberto(false);
        }}
        onCancelar={() => setModalAberto(false)}
      />
    </Form.Group>
  );
};

export default CamposMata;
